export default __webpack_public_path__ + "static/media/hero_r_side.5a35db0a.png";